import { useState } from "react";
import { Search, Eye, ChevronLeft, ChevronRight, X, ChevronDown, Image as ImageIcon } from "lucide-react";

// Comprehensive gallery data with aesthetics-appropriate photos
const galleryData = [
  {
    id: 1,
    date: "20 Apr 2024",
    client: "Emma Taylor",
    treatment: "Botox – Upper Face",
    treatmentId: "TRT-10452",
    photoType: "Before",
    practitioner: "Dr. Saleema",
    photos: [
      "https://lirp.cdn-website.com/54fa23f6/dms3rep/multi/opt/Before-49e05053-44482786-1920w.jpg", // Forehead wrinkles
    ]
  },
  {
    id: 2,
    date: "20 Apr 2024",
    client: "Emma Taylor",
    treatment: "Botox – Upper Face",
    treatmentId: "TRT-10452",
    photoType: "After",
    practitioner: "Dr. Saleema",
    photos: [
      "https://lirp.cdn-website.com/54fa23f6/dms3rep/multi/opt/After-d3e8c309-58a90bf2-1920w.jpg", // Smooth forehead
    ]
  },
  {
    id: 3,
    date: "17 Apr 2024",
    client: "Sarah Miller",
    treatment: "Dermal Fillers – Lips",
    treatmentId: "TRT-10343",
    photoType: "Before",
    practitioner: "Emma Griffin",
    photos: [
      "https://lirp.cdn-website.com/54fa23f6/dms3rep/multi/opt/Before+0.5ml+Lip+Enhancement-640w.jpg", // Natural lips
    ]
  },
  {
    id: 4,
    date: "17 Apr 2024",
    client: "Sarah Miller",
    treatment: "Dermal Fillers – Lips",
    treatmentId: "TRT-10343",
    photoType: "After",
    practitioner: "Emma Griffin",
    photos: [
      "https://lirp.cdn-website.com/54fa23f6/dms3rep/multi/opt/After+0.5ml+Lip+Enhancement-640w.jpg", // Enhanced lips
    ]
  },
  {
    id: 5,
    date: "15 Apr 2024",
    client: "Laura Brown",
    treatment: "8 Point Face Lift",
    treatmentId: "TRT-10334",
    photoType: "Before",
    practitioner: "Dr. Harper",
    photos: [
      "https://lirp.cdn-website.com/54fa23f6/dms3rep/multi/opt/Eight-Point-Before-6e5526e5-f0ef9b86-1920w.jpg", // Mid-face laxity
    ]
  },
  {
    id: 6,
    date: "15 Apr 2024",
    client: "Laura Brown",
    treatment: "8 Point Face Lift",
    treatmentId: "TRT-10334",
    photoType: "After",
    practitioner: "Dr. Harper",
    photos: [
      "https://lirp.cdn-website.com/54fa23f6/dms3rep/multi/opt/Eight-Point-After-1920w.jpg", // Lifted mid-face
    ]
  },
  {
    id: 7,
    date: "12 Apr 2024",
    client: "James Mitchell",
    treatment: "Tear Trough Treatment",
    treatmentId: "TRT-10355",
    photoType: "Before",
    practitioner: "Kate Morgan",
    photos: [
      "https://lirp.cdn-website.com/54fa23f6/dms3rep/multi/opt/Under+Eye+Treatment+Before-1920w.jpg", // Hollowing
    ]
  },
  {
    id: 8,
    date: "12 Apr 2024",
    client: "James Mitchell",
    treatment: "Tear Trough Treatment",
    treatmentId: "TRT-10355",
    photoType: "After",
    practitioner: "Kate Morgan",
    photos: [
      "https://lirp.cdn-website.com/54fa23f6/dms3rep/multi/opt/Under+Eye+Treatment+After-1920w.jpg", // Smoothed area
    ]
  },
  {
    id: 9,
    date: "10 Apr 2024",
    client: "Rachel Adams",
    treatment: "Naso-labial Folds",
    treatmentId: "TRT-10362",
    photoType: "Before",
    practitioner: "Emma Taylor",
    photos: [
      "https://lirp.cdn-website.com/54fa23f6/dms3rep/multi/opt/Naso+Labial+Before-1920w.jpg", // Deep folds
    ]
  },
  {
    id: 10,
    date: "10 Apr 2024",
    client: "Rachel Adams",
    treatment: "Naso-labial Folds",
    treatmentId: "TRT-10362",
    photoType: "After",
    practitioner: "Emma Taylor",
    photos: [
      "https://lirp.cdn-website.com/54fa23f6/dms3rep/multi/opt/Naso-Labial-After-988d22cb-1920w.jpg", // Reduced folds
    ]
  },
  {
    id: 11,
    date: "8 Apr 2024",
    client: "Sophie Anderson",
    treatment: "Skin Booster",
    treatmentId: "TRT-10463",
    photoType: "Before",
    practitioner: "Dr. Saleema",
    photos: [
      "https://lirp.cdn-website.com/54fa23f6/dms3rep/multi/opt/M-M+Before+-+After+skin+booster+mouth+lines+44+Website+-640w.png", // Texture signs
    ]
  },
  {
    id: 12,
    date: "8 Apr 2024",
    client: "Sophie Anderson",
    treatment: "Skin Booster",
    treatmentId: "TRT-10463",
    photoType: "After",
    practitioner: "Dr. Saleema",
    photos: [
      "https://lirp.cdn-website.com/54fa23f6/dms3rep/multi/opt/M-M+Before+-+After+Skin+Booster+under+eyes+Website+-640w.png", // Rejuvenated look
    ]
  },
];

// Photo Modal Component
const PhotoModal = ({ isOpen, onClose, photos, title }: { isOpen: boolean; onClose: () => void; photos: string[]; title: string }) => {
  if (!isOpen) return null;

  return (
    <div 
      className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4"
      onClick={onClose}
    >
      <div 
        className="bg-white rounded-lg max-w-4xl w-full max-h-[85vh] overflow-hidden flex flex-col"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Modal Header */}
        <div className="flex items-center justify-between p-6 border-b border-gray-200">
          <h3 className="text-xl font-semibold text-gray-900">{title}</h3>
          <button
            onClick={onClose}
            className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
          >
            <X size={24} className="text-gray-500" />
          </button>
        </div>

        {/* Modal Content - Scrollable */}
        <div className="p-6 overflow-y-auto flex-1">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {photos.map((photo, index) => (
              <div key={index} className="border border-gray-200 rounded-lg overflow-hidden">
                <img
                  src={photo}
                  alt={`Photo ${index + 1}`}
                  className="w-full h-64 object-cover"
                />
                <div className="p-3 bg-gray-50">
                  <p className="text-sm text-gray-600 font-medium">Photo {index + 1}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Modal Footer */}
        <div className="px-6 py-4 bg-gray-50 border-t border-gray-200">
          <button 
            onClick={onClose}
            className="w-full px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 transition-colors font-medium"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

const AestheticGallery = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedClient, setSelectedClient] = useState("All");
  const [selectedTreatment, setSelectedTreatment] = useState("All");
  const [selectedPractitioner, setSelectedPractitioner] = useState("All");
  const [selectedPhotoType, setSelectedPhotoType] = useState("All");
  const [selectedTimeFilter, setSelectedTimeFilter] = useState("All Time");
  const [showTimeDropdown, setShowTimeDropdown] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedPhotos, setSelectedPhotos] = useState<{ photos: string[]; title: string } | null>(null);

  const itemsPerPage = 10;

  const timeFilterOptions = ["All Time", "Today", "This Week", "This Month", "Last Month", "Last 3 Months", "This Year"];

  // Get unique values for filters
  const clients = ["All", ...Array.from(new Set(galleryData.map(item => item.client)))];
  const treatments = ["All", ...Array.from(new Set(galleryData.map(item => item.treatment)))];
  const practitioners = ["All", ...Array.from(new Set(galleryData.map(item => item.practitioner)))];
  const photoTypes = ["All", "Before", "After"];

  // Filter data based on selected filters
  const filteredData = galleryData.filter(item => {
    const matchesSearch = searchTerm === "" || 
      item.client.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.treatment.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.treatmentId.toLowerCase().includes(searchTerm.toLowerCase());
    
    const matchesClient = selectedClient === "All" || item.client === selectedClient;
    const matchesTreatment = selectedTreatment === "All" || item.treatment === selectedTreatment;
    const matchesPractitioner = selectedPractitioner === "All" || item.practitioner === selectedPractitioner;
    const matchesPhotoType = selectedPhotoType === "All" || item.photoType === selectedPhotoType;

    return matchesSearch && matchesClient && matchesTreatment && matchesPractitioner && matchesPhotoType;
  });

  const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const paginatedData = filteredData.slice(startIndex, startIndex + itemsPerPage);

  const handleReset = () => {
    setSearchTerm("");
    setSelectedClient("All");
    setSelectedTreatment("All");
    setSelectedPractitioner("All");
    setSelectedPhotoType("All");
    setSelectedTimeFilter("All Time");
    setCurrentPage(1);
  };

  const handleViewPhotos = (item: typeof galleryData[0]) => {
    setSelectedPhotos({
      photos: item.photos,
      title: `${item.client} - ${item.treatment} (${item.photoType})`
    });
  };

  return (
    <div className="">
      <div className="flex flex-col w-full h-full">
        {/* Header */}
        <div className="bg-white px-6 py-6 border-b border-gray-200">
          <div className="flex items-center gap-3 mb-2">
            <div className="w-10 h-10 bg-purple-100 rounded-lg flex items-center justify-center">
              <ImageIcon className="w-5 h-5 text-purple-600" />
            </div>
            <div>
              <h1 className="text-2xl font-bold text-gray-900">Gallery</h1>
              <p className="text-sm text-gray-500">View and manage treatment photos</p>
            </div>
          </div>
        </div>

        {/* Filters Toolbar */}
        <div className="flex flex-wrap items-center gap-3 py-4 px-4 lg:px-0">
          {/* All Time Dropdown Filter */}
          <div className="relative">
            <button 
              onClick={() => setShowTimeDropdown(!showTimeDropdown)}
              className="flex items-center gap-2 px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 transition-colors text-sm font-medium"
            >
              <span>📅</span>
              <span>{selectedTimeFilter}</span>
              <ChevronDown size={16} />
            </button>
            
            {showTimeDropdown && (
              <div className="absolute top-full left-0 mt-1 bg-white border border-gray-200 rounded-lg shadow-lg z-10 min-w-[180px]">
                {timeFilterOptions.map(option => (
                  <button
                    key={option}
                    onClick={() => {
                      setSelectedTimeFilter(option);
                      setShowTimeDropdown(false);
                      setCurrentPage(1);
                    }}
                    className={`w-full text-left px-4 py-2 text-sm hover:bg-purple-50 transition-colors ${
                      selectedTimeFilter === option ? "bg-purple-50 text-purple-700 font-medium" : "text-gray-700"
                    }`}
                  >
                    {option}
                  </button>
                ))}
              </div>
            )}
          </div>

          {/* Client Dropdown */}
          <select 
            value={selectedClient}
            onChange={(e) => setSelectedClient(e.target.value)}
            className="px-4 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-purple-600 bg-white"
          >
            {clients.map(client => (
              <option key={client} value={client}>{client === "All" ? "Client" : client}</option>
            ))}
          </select>

          {/* Search Bar */}
          <div className="relative flex-1 min-w-[200px]">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
            <input
              type="text"
              placeholder="Search by client name..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-purple-600"
            />
          </div>

          {/* All Treatments Dropdown */}
          <select 
            value={selectedTreatment}
            onChange={(e) => setSelectedTreatment(e.target.value)}
            className="px-4 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-purple-600 bg-white"
          >
            {treatments.map(treatment => (
              <option key={treatment} value={treatment}>
                {treatment === "All" ? "All Treatments" : treatment}
              </option>
            ))}
          </select>

          {/* All Practitioners Dropdown */}
          <select 
            value={selectedPractitioner}
            onChange={(e) => setSelectedPractitioner(e.target.value)}
            className="px-4 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-purple-600 bg-white"
          >
            {practitioners.map(practitioner => (
              <option key={practitioner} value={practitioner}>
                {practitioner === "All" ? "All Practitioners" : practitioner}
              </option>
            ))}
          </select>

          {/* Before/After Dropdown */}
          <select 
            value={selectedPhotoType}
            onChange={(e) => setSelectedPhotoType(e.target.value)}
            className="px-4 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-purple-600 bg-white"
          >
            {photoTypes.map(type => (
              <option key={type} value={type}>
                {type === "All" ? "Before / After" : type}
              </option>
            ))}
          </select>

          {/* Reset Button */}
          <button 
            onClick={handleReset}
            className="px-4 py-2 text-purple-600 hover:bg-purple-50 rounded-lg transition-colors text-sm font-medium"
          >
            Reset
          </button>
        </div>

        {/* Main Content */}
        <div className="flex-1 pb-6 px-4 lg:px-0">
          <div className="rounded-xl lg:border border-gray-200 lg:shadow-sm bg-white overflow-hidden">
            <div className="overflow-x-auto">
              <table className="w-full">
                <thead className="bg-[#885ABB] border-b border-gray-100">
                  <tr>
                    <th className="px-6 py-4 text-left text-sm font-bold text-white">Date</th>
                    <th className="px-6 py-4 text-left text-sm font-bold text-white">Client</th>
                    <th className="px-6 py-4 text-left text-sm font-bold text-white">Treatment</th>
                    <th className="px-6 py-4 text-left text-sm font-bold text-white">Treatment ID</th>
                    <th className="px-6 py-4 text-left text-sm font-bold text-white">Photo Type</th>
                    <th className="px-6 py-4 text-left text-sm font-bold text-white">Practitioner</th>
                    <th className="px-6 py-4 text-left text-sm font-bold text-white">Action</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-100">
                  {paginatedData.length > 0 ? (
                    paginatedData.map((item) => (
                      <tr key={item.id} className="hover:bg-purple-50/30 transition-colors">
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{item.date}</td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-purple-600 font-medium">{item.client}</td>
                        <td className="px-6 py-4 text-sm text-gray-900">{item.treatment}</td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-purple-600 font-medium">{item.treatmentId}</td>
                        <td className="px-6 py-4 whitespace-nowrap">
                          <span className={`inline-flex px-3 py-1 text-xs font-medium rounded-full ${
                            item.photoType === "Before" ? "bg-purple-100 text-purple-700" : "bg-gray-100 text-gray-700"
                          }`}>
                            {item.photoType}
                          </span>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{item.practitioner}</td>
                        <td className="px-6 py-4 whitespace-nowrap">
                          <button 
                            onClick={() => handleViewPhotos(item)}
                            className="flex items-center gap-2 text-purple-600 hover:text-purple-700 transition-colors"
                          >
                            <Eye size={18} />
                            <span className="text-sm font-medium">View Photos</span>
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={7} className="px-6 py-12 text-center">
                        <Search className="w-12 h-12 mx-auto mb-3 text-gray-300" />
                        <p className="text-lg font-medium text-gray-500">No photos found</p>
                        <p className="text-sm text-gray-400">Try adjusting your filters</p>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>

          {/* Pagination */}
          {filteredData.length > 0 && totalPages > 1 && (
            <div className="flex flex-col sm:flex-row items-center justify-between px-4 lg:px-6 py-4 mt-4 gap-4 bg-white rounded-xl shadow-sm border border-gray-100">
              <div className="text-sm text-gray-600 font-medium order-2 sm:order-1">
                Showing <span className="text-gray-900">{startIndex + 1}</span> to <span className="text-gray-900">{Math.min(startIndex + itemsPerPage, filteredData.length)}</span> of <span className="text-gray-900">{filteredData.length}</span> photos
              </div>
              <div className="flex items-center gap-3 order-1 sm:order-2">
                <button
                  onClick={() => setCurrentPage(prev => Math.max(1, prev - 1))}
                  disabled={currentPage === 1}
                  className="px-4 py-2 border border-gray-300 rounded-lg text-sm font-semibold text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-40 disabled:cursor-not-allowed transition-all"
                >
                  Prev
                </button>
                <div className="bg-purple-50 px-3 py-1.5 rounded-lg text-purple-700 text-sm font-bold min-w-[80px] text-center border border-purple-100">
                  {currentPage} / {totalPages}
                </div>
                <button
                  onClick={() => setCurrentPage(prev => Math.min(totalPages, prev + 1))}
                  disabled={currentPage === totalPages}
                  className="px-4 py-2 border border-gray-300 rounded-lg text-sm font-semibold text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-40 disabled:cursor-not-allowed transition-all"
                >
                  Next
                </button>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Photo Modal */}
      {selectedPhotos && (
        <PhotoModal
          isOpen={true}
          onClose={() => setSelectedPhotos(null)}
          photos={selectedPhotos.photos}
          title={selectedPhotos.title}
        />
      )}
    </div>
  );
};

export default AestheticGallery;